module.exports = __webpack_public_path__ + "img/whats-new-20_en.12479aa.jpg";